// functions that are use on page EditZones.js to draw new zones

function formatCoordinates(canvas, rect, x, y) {
  const scaleX = canvas.width / rect.width;
  const scaleY = canvas.height / rect.height;
  const currentCoordinates = {
    x: (x - rect.left) * scaleX,
    y: (y - rect.top) * scaleY,
  };

  return currentCoordinates;
}

function cleanCanvas(context, canvas) {
  context.clearRect(0, 0, canvas.width, canvas.height);
}

function drawLine(context, color, x1, y1, x2, y2) {
  context.lineWidth = 3;
  context.strokeStyle = color;
  context.lineCap = "round";

  context.beginPath();
  context.moveTo(x1, y1);
  context.lineTo(x2, y2);
  context.stroke();
}

function drawCircle(context, color, radius, x, y) {
  context.strokeStyle = color;

  context.beginPath();
  context.arc(x, y, radius, 0, 2 * Math.PI);
  context.fillStyle = color;
  context.fill();
  context.stroke();
}

function drawAlignedRect(context, x1, y1, x2, y2, width = 50) {
  const length = Math.sqrt((x2 - x1) ** 2 + (y2 - y1) ** 2);
  const angle = Math.atan2(y2 - y1, x2 - x1);

  context.save();
  context.translate(x1, y1);
  context.rotate(angle);

  context.lineWidth = 3;

  const color1 = "#FF00FF";
  const color2 = "#FF00FF";

  context.lineWidth = 3;

  context.strokeStyle = color1;
  context.strokeRect(0, 3, length, width);

  context.strokeStyle = color2;
  context.strokeRect(0, -3, length, -width);

  context.restore();
}

function drawCoordinates(
  context,
  zones,
  editMode,
  zoneBeingEdited,
  canvas,
  clean = true
) {
  if (clean) {
    cleanCanvas(context, canvas);
  }

  zones.forEach((zone) => {
    zone.coordinates.forEach((coordinate) => {
      const x1y1 = {
        x: coordinate[0].x,
        y: coordinate[0].y,
      };
      const x2y2 = {
        x: coordinate[1].x,
        y: coordinate[1].y,
      };

      const color =
        editMode && zone.id !== zoneBeingEdited ? "gray" : zone.color;

      drawLine(context, color, x1y1.x, x1y1.y, x2y2.x, x2y2.y);

      if (editMode && zone.id === zoneBeingEdited) {
        drawCircle(context, color, 5, x2y2.x, x2y2.y);
      }
    });
  });
}

function drawArrow(context, x, y, angle, color) {
  const arrowLength = 36;
  const arrowWidth = 14;
  const headLength = 18;

  context.save();
  context.translate(x, y);
  context.rotate(angle);

  context.beginPath();
  context.moveTo(0, -arrowWidth / 2);
  context.lineTo(arrowLength - headLength, -arrowWidth / 2);
  context.lineTo(arrowLength - headLength, -arrowWidth);
  context.lineTo(arrowLength, 0);
  context.lineTo(arrowLength - headLength, arrowWidth);
  context.lineTo(arrowLength - headLength, arrowWidth / 2);
  context.lineTo(0, arrowWidth / 2);
  context.closePath();

  context.fillStyle = color;
  context.fill();

  context.restore();
}

function drawLineCoordinates(
  context,
  lines,
  editMode,
  lineBeingEdited,
  canvas,
  clean = true,
  showDirectionArrows = false,
  directionLineId = null
) {
  if (clean) {
    cleanCanvas(context, canvas);
  }

  lines.forEach((line) => {
    line.coordinates.forEach((coordinate) => {
      const point1 = coordinate[0];
      const point2 = coordinate[1];

      const color =
        editMode && line.id !== lineBeingEdited ? "gray" : line.color;

      drawLine(context, color, point1.x, point1.y, point2.x, point2.y);

      if (showDirectionArrows && directionLineId === line.id) {
        const midX = (point1.x + point2.x) / 2;
        const midY = (point1.y + point2.y) / 2;
        const angle = Math.atan2(point2.y - point1.y, point2.x - point1.x);
        drawArrow(context, midX, midY, angle + Math.PI / 2, "#2979FF");
        drawArrow(context, midX, midY, angle - Math.PI / 2, "#8F00FF");
      }

      if (editMode && line.id === lineBeingEdited) {
        drawCircle(context, color, 5, point1.x, point1.y);
        drawCircle(context, color, 5, point2.x, point2.y);
      }
    });
  });
}

function checkProximity(x1, y1, x2, y2) {
  const distance = Math.sqrt((x2 - x1) ** 2 + (y2 - y1) ** 2);
  return distance < 10;
}

function checkVerticeProximity(x1, y1, x2, y2) {
  return Math.sqrt((x2 - x1) ** 2 + (y2 - y1) ** 2) < 20;
}

function checkZoneCrossOther(zone, zones) {
  let is_inside = false;

  zones.forEach((other_zone) => {
    if (other_zone.id !== zone.id) {
      const sharedCoordinates = zone.coordinates.some((coord) =>
        other_zone.coordinates.some(
          (otherCoord) =>
            coord[0].x === otherCoord[0].x && coord[0].y === otherCoord[0].y
        )
      );
      if (sharedCoordinates) {
        return;
      }

      zone.coordinates.forEach((coordinate) => {
        other_zone.coordinates.forEach((other_coordinate) => {
          const [x1, y1] = [coordinate[0].x, coordinate[0].y];
          const [x2, y2] = [coordinate[1].x, coordinate[1].y];

          const [x3, y3] = [other_coordinate[0].x, other_coordinate[0].y];
          const [x4, y4] = [other_coordinate[1].x, other_coordinate[1].y];

          const d = (x1 - x2) * (y3 - y4) - (y1 - y2) * (x3 - x4);

          if (d !== 0) {
            // parallel lines
            const t = ((x1 - x3) * (y3 - y4) - (y1 - y3) * (x3 - x4)) / d;
            const u = -((x1 - x2) * (y1 - y3) - (y1 - y2) * (x1 - x3)) / d;

            if (t >= 0 && t <= 1 && u >= 0 && u <= 1) {
              is_inside = true;
            }
          }
        });
      });
    }
  });
  return is_inside;
}

function handleNewLine(
  event,
  canvas,
  currentClick,
  currentColor,
  drawMode,
  zones,
  zoneBeingEdited,
  lines,
  lineBeingEdited,
  editMode
) {
  const rect = canvas.getBoundingClientRect();
  const context = canvas.getContext("2d");

  const currentCoordinates = formatCoordinates(
    canvas,
    rect,
    event.clientX,
    event.clientY
  );

  context.clearRect(0, 0, canvas.width, canvas.height);
  if (drawMode === "zone") {
    drawCoordinates(context, zones, editMode, zoneBeingEdited, canvas);
  } else if (drawMode === "line") {
    drawLineCoordinates(context, lines, editMode, lineBeingEdited, canvas);
  }
  drawLine(
    context,
    currentColor,
    currentClick.x,
    currentClick.y,
    currentCoordinates.x,
    currentCoordinates.y
  );
}

function checkProximityWithOtherZones(currentCoordinates, zones, currentId) {
  for (let zone of zones) {
    if (zone.id !== currentId) {
      for (let coordinateArray of zone.coordinates) {
        for (let vertex of coordinateArray) {
          const x1 = vertex.x;
          const y1 = vertex.y;

          if (
            checkVerticeProximity(
              x1,
              y1,
              currentCoordinates.x,
              currentCoordinates.y
            )
          ) {
            currentCoordinates.x = x1;
            currentCoordinates.y = y1;
            return true;
          }
        }
      }
    }
  }
  return false;
}

export {
  formatCoordinates,
  cleanCanvas,
  drawLine,
  drawCircle,
  drawAlignedRect,
  drawCoordinates,
  drawLineCoordinates,
  checkProximity,
  checkVerticeProximity,
  checkZoneCrossOther,
  handleNewLine,
  checkProximityWithOtherZones,
  drawArrow,
};
